export const navigation = [
  { path: "/", label: "Overview" },
  { path: "/pipeline", label: "Pipeline" },
  { path: "/trials", label: "Trials" },
  { path: "/evidence", label: "Evidence" },
  { path: "/regulatory", label: "Regulatory" },
] as const;
